<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>{{ settings.phone || '400-888-9999' }}
          <span class="glyphicon glyphicon-envelope"></span>{{ settings.email || 'service@official-website.com' }}
          <span class="glyphicon glyphicon-time"></span>{{ settings.serviceHours || '7x24小时为您服务' }}
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>{{ settings.topbarSlogan || '赶快联系我们吧！' }}
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img :src="logoUrl || defaultLogo" alt="logo">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in visibleNavList"
          :key="item.path || index"
          :class="[index==navIndex?'active':'', item.path === '/jobchance' ? 'nav-job-btn-item' : '']"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path" :class="item.path === '/jobchance' ? 'btn-job-highlight' : ''">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i v-if="item.path !== '/jobchance'" class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" :src="logoUrl || defaultLogo" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in visibleNavList"
            :key="item.path || index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      logoUrl: '',
      defaultLogo: require('@/assets/img/logo_black.png'),
      settings: {},
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          visible: true,
          children: []
        },
        {
          name: "软件产品",
          path: "/software",
          visible: true,
          children: []
        },
        {
          name: "相关服务",
          path: "/service",
          visible: true,
          children: []
        },
        {
          name: "新闻动态",
          path: "/newsinformation",
          visible: true,
          children: []
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          visible: true,
          children: []
        },
        {
          name: "招聘岗位",
          path: "/jobchance",
          visible: true,
          children: []
        }
      ]
    };
  },
  computed: {
    visibleNavList() {
      return this.navList.filter(item => item.visible !== false);
    }
  },
  created() {
    this.fetchSettings();
    this.fetchNavMenu();
    this.fetchProducts();
  },
  methods: {
    async fetchNavMenu() {
      try {
        const res = await fetch('/api/navMenu');
        const json = await res.json();
        if (json.code === 200 && Array.isArray(json.data)) {
          json.data.forEach(item => {
            const navItem = this.navList.find(n => n.path === item.path);
            if (navItem) {
              if (item.name) navItem.name = item.name;
              if (item.visible !== undefined) navItem.visible = item.visible;
            }
          });
        }
      } catch (e) {}
    },
    async fetchSettings() {
      try {
        const res = await fetch('/api/settings');
        const json = await res.json();
        if (json.code === 200) {
          this.settings = json.data;
          if (json.data.siteLogoBlack) {
            this.logoUrl = json.data.siteLogoBlack;
          }
        }
      } catch (e) {}
    },
    async fetchProducts() {
      try {
        const res = await fetch('/api/products');
        const json = await res.json();
        if (json.code === 200 && Array.isArray(json.data) && json.data.length > 0) {
          const activeProducts = json.data.filter(p => p.status !== '已下线');
          const productNav = this.navList.find(n => n.path === '/software');
          if (productNav && activeProducts.length > 0) {
            productNav.children = activeProducts.map(p => {
              let path = `/software/detail?id=${p.id}`;
              if (p.name && p.name.includes('智能小镇')) path = '/software/smartTown';
              else if (p.name && p.name.includes('大数据')) path = '/software/bigData';
              return {
                name: p.name,
                path: path
              };
            });
          }
        }
      } catch (e) {
        try {
          const res2 = await fetch('http://localhost:8030/api/products');
          const json2 = await res2.json();
          if (json2.code === 200 && Array.isArray(json2.data) && json2.data.length > 0) {
            const activeProducts = json2.data.filter(p => p.status !== '已下线');
            const productNav = this.navList.find(n => n.path === '/software');
            if (productNav && activeProducts.length > 0) {
              productNav.children = activeProducts.map(p => {
                let path = `/software/detail?id=${p.id}`;
                if (p.name && p.name.includes('智能小镇')) path = '/software/smartTown';
                else if (p.name && p.name.includes('大数据')) path = '/software/bigData';
                return {
                  name: p.name,
                  path: path
                };
              });
            }
          }
        } catch (err) {}
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f6f9;
  border-bottom: 1px solid #e9edf2;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  transition: all ease 0.6s;
}
#header .header-top {
  height: 44px;
  color: #fff;
  font-size: 12px;
  line-height: 44px;
  background: #162A56;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 85px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 170px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 160px;
  height: 60px;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 85px;
  float: right;
  margin: 0;
  max-width: 860px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 12px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #262626;
  font-size: 15px;
  font-weight: 600;
  padding: 10px 2px;
  position: relative;
  transition: color 0.2s ease;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.4s ease;
  background-color: #3370FF;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #3370FF;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #3370FF;
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li.active > a > .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 招聘岗位专属高亮胶囊按钮 (CTA) */
#header .header-nav .header-nav-wrapper > li.nav-job-btn-item {
  margin-left: 18px;
}
#header .header-nav .header-nav-wrapper > li.nav-job-btn-item > a.btn-job-highlight {
  display: inline-block;
  background: #3370FF;
  color: #ffffff !important;
  padding: 8px 22px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 14px rgba(51, 112, 255, 0.25);
  transition: all 0.3s ease;
  border: 1px solid #3370FF;
}
#header .header-nav .header-nav-wrapper > li.nav-job-btn-item > a.btn-job-highlight:hover {
  background: #2058db;
  border-color: #2058db;
  color: #ffffff !important;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(51, 112, 255, 0.35);
}
#header .header-nav .header-nav-wrapper > li.nav-job-btn-item.active > a.btn-job-highlight {
  background: #162A56;
  border-color: #162A56;
  box-shadow: 0 4px 14px rgba(22, 42, 86, 0.3);
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 140px;
    height: 60px;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #162A56;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #162A56;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue